import { render } from "./SuccessStories.vue?vue&type=template&id=d47301cc&scoped=true&ts=true"
import script from "./SuccessStories.vue?vue&type=script&lang=ts"
export * from "./SuccessStories.vue?vue&type=script&lang=ts"

import "./SuccessStories.vue?vue&type=style&index=0&id=d47301cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47301cc"]])

export default __exports__